import { useQuery, UseQueryResult } from 'react-query';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

export interface OnboardingStep {
  id: number;
  organizationId: number;
  step: string;
  status: string;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

const useGetOnboardingSteps = (): UseQueryResult<ApiResponse<OnboardingStep[]>, ApiError<unknown>> => useQuery<ApiResponse<OnboardingStep[]>, ApiError<unknown>>(
  ['onboarding-steps'],
  () => dataFetch.get(`${CORE_API_SUFFIX}digger-core-api/onboarding/steps`),
);

export default useGetOnboardingSteps;
